{
  "breadcrumb.new": "Novo",
  "breadcrumb.edit": "Edição",
  "breadcrumb.processes": "Processos",
  "breadcrumb.danger-zones": "Configuração de Risco | Meta",
  "breadcrumb.management-report": "Relatórios",
  "breadcrumb.reports": "Relatórios",
  "breadcrumb.delay": "Gestão de Atrasos Timeline",
  "breadcrumb.delay-management": "Gestão de Atrasos Timeline"
}
